<template>
  <div class="challenge-icon">
    <i :class="challengeIconClass" />
  </div>
</template>

<script>
  import './ChallengeIcon.scss';
  import { CHALLENGE_TYPE_WHEN_AND_WHERE, CHALLENGE_TYPE_HUNT } from '~/constants/PQConstants';

  export default {
    props: ['challenge', 'type'],
    computed: {
      challengeIconClass() {
        if (this.type === CHALLENGE_TYPE_WHEN_AND_WHERE || this.challenge.challenge_type.type === CHALLENGE_TYPE_WHEN_AND_WHERE) {
          return 'fas fa-street-view';
        } else if (this.type === CHALLENGE_TYPE_HUNT || this.challenge.challenge_type.type === CHALLENGE_TYPE_HUNT) {
          return 'fas fa-crosshairs';
        }
      }
    }
  };
</script>